import { Controller } from "@hotwired/stimulus";
import { get } from "@rails/request.js";

export default class extends Controller {
  static targets = ["state"];
  static values = {
    url: String,
  }

  stateTargetConnected(element){    
    const currentState = element.value;

    if(["transcoding", "uploaded"].includes(currentState)) {
      const handleTimeOut = async () => {
        const res = await get(this.urlValue, { responseKind: "turbo-stream"} );   
        console.log(res)   
      }
  
      setTimeout(handleTimeOut, 3000);
    }
  }
}
